import React, {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import {Pencil} from "lucide-react";
import {MdArrowBack} from "react-icons/md";
import Dropdown from "../../Component/Dropdown/Drowdown";
import toast from "react-hot-toast";


export default function UserDetails() {


    const {id} = useParams();
    const navigate = useNavigate();

    const [update, setUpdate] = useState(false);

    const [User, setUser] = useState({
        userId: "",
        userName: "",
        email: "",
        address: "",
        country: {
            id: "",
            name: "",
        },
        password: "",
        mobile: "",
        createAt: "",
        updateAt: ""
    });


    const [loading, setLoading] = useState(true);
    const [loadingCountry, setLoadingCountry] = useState(false);
    const [loadingEdit, setLoadingEdit] = useState(false);

    const [showModalCategory, setShowModalCategory] = useState(false);


    const [CountryListData, setCountryListData] = useState([]);

    useEffect(() => {

        setLoading(true)
        apiRequests.get(`/api/user/v1/get-user-profile/${id}`)
            .then((response) => {
                const info = response.data.data;
                setUser({
                    userId: id,
                    userName: info.userName,
                    email: info.email,
                    address: info.address,
                    country: {
                        id: info.country._id,
                        name: info.country.name,
                    },
                    password: "",
                    mobile: info.mobile,
                    createAt: info.createAt,
                    updateAt: info.updateAt,
                });

            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));

    }, [update]);

    useEffect(() => {

        setLoadingCountry(true)
        apiRequests.get("/api/country/get-all?limit=20&page=1")
            .then((res) => {
                setCountryListData(res.data.data.docs)
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => {
                setLoadingCountry(false)
            });

    }, []);


    function EditUser() {

        const data = {

            userId: User.userId,
            userName: User.userName,
            email: User.email,
            address: User.address,
            country: User.country.id,
            password: User.password,
            mobile: User.mobile

        }

        setLoadingEdit(true)
        apiRequests.patch(`/api/user/v1/edit-user-by-admin`, data)
            .then(() => {
                toast.success("successfully updated product!")
                setUpdate(!update)
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoadingEdit(false));

    }


    const handleCountryChange = (selectedCountry) => {
        setUser((prevUser) => ({
            ...prevUser,
            country: selectedCountry,
        }));
        setShowModalCategory(false);
    };


    if (loading) return <div className="p-12"><Loading/></div>;
    if (!User) return <div className="text-center font-bold text-xl text-gray-500 mt-20">User not found</div>;


    return (


        <div className="max-w-6xl mx-auto">

            <div className="flex flex-col sm:flex-row mt-8 justify-between gap-4">

                <div className="flex gap-3 px-6">
                    <button
                        onClick={EditUser}
                        className="flex items-center bg-buttonColor-shade6 hover:bg-buttonColor-shade7 text-white px-4 py-2 rounded-lg gap-2"
                    >
                        {loadingEdit ?
                            <Loading textColor={"white-0"}/>
                            :
                            <>
                                <Pencil className="w-4 h-4"/>
                                Edit User
                            </>
                        }

                    </button>
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center border-2 hover:bg-black hover:text-white border-black text-baseColor-first px-4 py-2 rounded-lg gap-2"
                    >
                        <MdArrowBack/>
                        Back
                    </button>
                </div>

            </div>


            <div className="bg-white p-6">


                <div className="flex flex-col gap-8">


                    <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">

                        <h2 className="text-firstColor-shade9 text-2xl font-bold">Information</h2>

                        <div className="grid grid-cols-2 md:flex md:flex-col auto-cols-auto gap-5">

                            {/*<DetailItem label="Status">*/}
                            {/*        <span*/}
                            {/*            onClick={toggleStatus}*/}
                            {/*            className={`cursor-pointer inline-flex items-center px-3 py-1 rounded-full text-sm */}
                            {/*                 ${product.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}*/}
                            {/*                 `}*/}
                            {/*        >*/}
                            {/*            {product.isActive ? (*/}
                            {/*                <><Eye className="w-4 h-4 mr-2"/> Active</>*/}
                            {/*            ) : (*/}
                            {/*                <><EyeOff className="w-4 h-4 mr-2"/> Inactive</>*/}
                            {/*            )}*/}
                            {/*        </span>*/}
                            {/*</DetailItem>*/}


                            <DetailItem label="User name">
                                <input className="py-1 pl-2 bg-transparent outline-none w-full"
                                       value={User.userName}
                                       onChange={(e) => setUser({...User, userName: e.target.value})}
                                />
                            </DetailItem>

                            {/*<DetailItem label="Status">*/}
                            {/*    <input className="py-1 pl-2 bg-transparent outline-none w-full" value={Name}*/}
                            {/*           onChange={(e) => setName(e.target.value)}/>*/}
                            {/*</DetailItem>*/}


                            <DetailItem label="Mobile">

                                <input className="py-1 pl-2 bg-transparent outline-none w-full" type="number"
                                       value={User.mobile}
                                       onChange={(e) => setUser({...User, mobile: e.target.value})}
                                />
                            </DetailItem>


                            <DetailItem label="Address">

                                <input className="py-1 pl-2 bg-transparent outline-none w-full" type="text"
                                       value={User.address}
                                       onChange={(e) => setUser({...User, address: e.target.value})}
                                />
                            </DetailItem>


                            <DetailItem label="Country">
                                <div className="inline-block relative w-full"
                                     onClick={() => setShowModalCategory(!showModalCategory)}
                                >

                                    <input className="py-1 pl-2 bg-transparent outline-none w-full"
                                           value={User.country.name}
                                           readOnly
                                           placeholder="click for change Country"/>

                                    {showModalCategory &&
                                        <Dropdown data={CountryListData} setOpen={setShowModalCategory}
                                                  setValue={handleCountryChange}/>
                                    }

                                </div>
                            </DetailItem>

                            <DetailItem label="Email">

                                <input className="py-1 pl-2 bg-transparent outline-none w-full" type="text"
                                       value={User.email}
                                       onChange={(e) => setUser({...User, email: e.target.value})}
                                />
                            </DetailItem>

                            <DetailItem label="New Password">

                                <input className="py-1 pl-2 bg-transparent outline-none w-full" type="text"
                                       value={User.password}
                                       onChange={(e) => setUser({...User, password: e.target.value})}

                                />
                            </DetailItem>

                        </div>

                    </div>


                </div>
            </div>
        </div>
    );
}


const DetailItem = ({label, children}) => (
    <div className="flex flex-col gap-3 py-2 px-3 rounded-lg">
        <span className="text-gray-900">{label} :</span>
        <div className="text-gray-500 border-2 p-1 rounded-lg">{children}</div>
    </div>
);